import { Controller } from "stimulus"

export default class extends Controller {
    init_change_user_modal() {
        $('#ChangeUserModal').modal('show');
    }
}
